/** M47 — the self-trader the web shows, and its health probe: the eToro one, the only one since MT5 was switched off. */
export const SELF_TRADER_VENUE = "?venue=etoro";
export const SELF_TRADER_PROBE = "self-trader-etoro";

/** M15, H1, or D1 for M49's daily, multi-day strategies. */
export const timeframeLabel = (tf: 15 | 60 | 1440) => (tf === 1440 ? "D1" : tf === 60 ? "H1" : `M${tf}`);
/** M49 — a daily strategy holds for days; it is measured on paper and the demo account, never promoted. */
export const isMultiDay = (p: { timeframe: 15 | 60 | 1440 }) => p.timeframe === 1440;
